// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2ZEwO","resendInfoText":"OnGoingPaymentBox_resendInfoText__4TiTJ"};